import * as fb from '../../firebase'
import * as firebase from 'firebase/app'

export default {
  namespaced: true,
  
  state:{
    goals: {},
    goalslist:{},
    categories: {
      business: 'Business & Career',
      education: 'Learning & Personal Development',
      family: 'Love, Relationships & Parenting',
      financial: 'Money & Finances',
      health: 'Health, Fitness & Nutrition',
      social: 'Social Life, Friends & Fun',
      spiritual: 'Awareness, Beliefs & Values'
    },
    terms: {
      short: '90 days',
      medium: '3-12 months',
      long: '1-3 years'
    }
  },
  /* ================================================================ */
  mutations: {
    setGoals(state, payload) {
      state.goals= payload;
    },

    updateGoals(state, payload) {
      state.goals[payload.term]=payload.data
    },

    updateGoalsList(state, payload) {
      state.goalslist[payload.category]=payload.data
    },

    removeGoals(state, payload) {
      state.goalslist[payload.category] = state.goalslist[payload.category].filter(item => item.id != payload.id)
    },

  },
/* ================================================================ */
  actions: {
    async saveGoals({ state, dispatch}, payload) {
      //Either "goals" collection or "goals/category" document not created yet
      if (Object.keys(state.goals).length == 0) {
        dispatch('createGoals', payload);
        return;
      }
      else {
        dispatch('updateGoals', payload)
      }
    },

    async createGoals({ commit }, payload) {
      console.log('About to save new goals')
      const fieldname = payload.term + '_term';
      await fb.goalsCollection.doc(fb.auth.currentUser.uid).collection('goals').doc(payload.category).set({ [fieldname]: payload['data'] })
        .then(() => {
          commit('updateGoals', payload)
        })
        .catch(error => {
          console.log('Error creating goals:', error)
        });
    },

    async updateGoals({ commit }, payload) {
      console.log('About to update goals')
      const fieldname = payload.term + '_term';
      await fb.goalsCollection.doc(fb.auth.currentUser.uid).collection('goals').doc(payload.category).update({ [fieldname]: payload['data'] })
        .then(() => {
          commit('updateGoals', payload)
        })
        .catch(error => {
          console.log('Error updating goals:', error)
        });
    },

    async fetchGoals({ commit }, payload) {
      await fb.goalsCollection.doc(fb.auth.currentUser.uid).collection('goals').doc(payload.category).get()
        .then(doc => {
          if (doc.exists && doc.data()) {
            const goals = {}
            Object.keys(doc.data()).forEach( key => {
              var term = key.slice(0, key.indexOf('_'));
              var items=Object.values(doc.data()[key])
              goals[term] = items.sort((a, b) => a.priority - b.priority);
            })
            commit('setGoals', goals )
          }
          else {
            commit('setGoals', {})
            //console.log(`No ${payload.category} goals found`)
          }
        })
        .catch(error => {
          console.log('Error while fetching goals:', error)
        })
    },

    async deleteGoalsItem({ commit }, payload) {
      const fieldname=payload.term+'_term'
      await fb.goalsCollection.doc(fb.auth.currentUser.uid).collection('goals').doc(payload.category).update({ [fieldname + '.' + payload.id]: firebase.firestore.FieldValue.delete() }).then(() => {
        commit('removeGoals', payload)
      }).catch(error => {
        console.log('Error while deleting goals:', error)
      })

      //firebase.firestore.FieldValue.arrayRemove({id: payload.id}) }
    },

    async fetchGoalsList({ state, commit }, payload) {
      if (state.goalslist[payload.category]) {
        return;
      }

      await fb.goalsCollection.doc(fb.auth.currentUser.uid).collection('goals').doc(payload.category).get()
        .then(doc => {
          var goals = []
          if (doc.exists && doc.data()) {
            const keyTerms = Object.keys(doc.data()).sort().reverse();
            keyTerms.forEach(key => {
              var items = Object.values(doc.data()[key]);
              //Order goals by priority
              items=items.sort((a,b) => a.priority - b.priority);

              goals=goals.concat(items)
            })

          }
          commit('updateGoalsList', { category: payload.category, data: goals })
        }).catch(error => {
        console.log('Error while fetching goalslist', error)
      })
    },

   
  },
/* ================================================================ */
  getters: {
    getMaxDate :( ) => (term, targetDate) => {
      var theDate = targetDate ? new Date(targetDate) : new Date();

      if (term == 'short') {
        //within 60days
        theDate.setDate(theDate.getDate()+90);
      }
      else if (term == 'medium') {
        //90days-1year
        theDate.setFullYear(theDate.getFullYear()+1);
      }
      else if (term == 'long') {
        //1-3years
        theDate.setFullYear(theDate.getFullYear()+3);
      }
      else if (term == 'achieved') {
        theDate.setDate(theDate.getDate()-1);
      }

      var year = theDate.getFullYear();
      var month = (theDate.getMonth() + 1).toString().padStart(2, '0');
      var date = theDate.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${date}`;
    }
  }
}
